import {CheckCircleOutlined, CloseCircleOutlined} from "@ant-design/icons";

export const PrimarySelectWidget = ({checked, onCheckClick, props}) => {
    let icon;
    let color;
    if (checked) {
        icon = <CheckCircleOutlined />
        color = "#108ee9";
    } else {
        icon = <CloseCircleOutlined />
        color = "#8f8f8f"
    }

    const onSelect = () => {
        if (onCheckClick) onCheckClick();
    }

    const divStyle = {
        cursor: 'pointer',
        color
    }
    return <div style={divStyle} onClick={onSelect}>{icon}</div>
}